import React, {Component, Fragment} from 'react'
import {Stages, StyledForm} from 'components'
import {Authorization} from 'utils'
import Button from '@material-ui/core/Button'
import StyleSheet from 'styles'
import {
  Register,
  Disclaimer,
  Certification,
  SupportingDocuments,
  Kyc,
  Aml,
  Review,
  Unsupported
} from 'components/account'
import {InputDialog} from 'components/InputDialog'
import {DialogHandler} from 'utils/handlers'

export class AccountForm extends Component {
  state = {
    stage: -1,
    stages: [],
  }
  eventReasonDialogHandler = new DialogHandler(this, 'eventReasonDialogOpen')

  get status(){
    return this.props.context.status
  }

  get canSave(){
    return this.state.stage < this.state.stages.length - 1
  }

  get saveLabel() {
    return this.status === 'draft' ? 'Save Draft' : 'Update'
  }

  get submitEvent() {
    return Authorization.admin ? adminSubmitEvents[this.status] : userSubmitEvents[this.status]
  }

  get rejectEvent() {
    return Authorization.admin && rejectEvents[this.status]
  }

  handleNext = async () => {
    if (this.validateRef.validateStage(this.state.stage)) {
      try {
        await this.props.onSave()
      }
      catch (err) {
        window.scroll({top: 0, behavior: 'smooth'})
        throw (err)
      }
      this.handleStageChange(this.state.stage + 1, this.state.stages)
    }
    else {
      window.scroll({top: 0, behavior: 'smooth'})
    }

    this.validateRef.validate()
  }

  handleStageChange = (stage, stages) => {
    this.props.onSave()
    this.setState({stage, stages})
  }

  handleSave = async(event, isRejection) => {
    const reason = isRejection ? await this.eventReasonDialogHandler.show() : undefined
    if (isRejection && !reason)
      return

    try {
      await this.props.onSave(event, reason)
    } catch (err) {
      window.scroll({top: 0, behavior: 'smooth'})
      throw err
    }
    finally {
      if (event)
        this.setState({submitted: true})

      this.validateRef.validate()
    }
  }

  handleSendKycInstructions = async () => {
    if (this.validateRef.validateStage(this.state.stage)) {
      await this.props.onSendKycInstructions('email')
      this.handleStageChange(this.state.stage + 1, this.state.stages)
    } else {
      window.scroll({top: 0, behavior: 'smooth'})
      this.validateRef.validate()
    }
  }

  renderActions = () =>
    (this.props.context.country.supported || this.status === 'draft') &&
      <Fragment>
        {this.rejectEvent &&
        <Button variant="contained" color="secondary" onClick={() => this.handleSave(this.rejectEvent, true)}>
          {eventLabels[this.rejectEvent]}
        </Button>
        }
        {this.submitEvent &&
          <Button variant="contained" color="primary" onClick={() => this.handleSave(this.submitEvent)}>
            {eventLabels[this.submitEvent]}
          </Button>
        }
      </Fragment>

  render = () => {
    const {tncs, onChange, context, errors, amlInfo, certAgreement, kycConsent, onSendKycInstructions, countries} = this.props
    const {country, status, type, registeredFor, requireAml} = context
    const {stage, stages} = this.state
    const canKyc = status !== 'draft' && country.supported
    return (
      <StyledForm className={styles.form}>
        <Stages
          context={context}
          errors={errors}
          onChange={onChange}
          stage={stage}
          onStageChange={this.handleStageChange}
          complete={this.state.submitted}
          validateRef={ref => this.validateRef = ref}
        >
          <Register tncs={tncs} certAgreement={certAgreement}/>
          <Disclaimer hideRequiredFieldHelper />
          {type !== 'issuerAccounts' &&
            <Certification title={`${country.certificationHeading}: ${country.name}`} hidden={!canKyc} hideRequiredFieldHelper />
          }
          <Unsupported hidden={status === 'draft' || country.supported}/>
          <SupportingDocuments hidden={!canKyc} hideRequiredFieldHelper/>
          <Kyc hidden={!canKyc} kycConsent={kycConsent} onSendInstructions={onSendKycInstructions} countries={countries}/>
          <Aml hidden={!(canKyc && (requireAml || registeredFor === 'trust'))} amlInfo={amlInfo}/>
          <Review hidden={!canKyc} showRequireAml/>

        </Stages>
        <InputDialog title={eventLabels[this.rejectEvent]} label="Reason" {...this.eventReasonDialogHandler.props} valueRequired/>

        <div className={styles.buttonBox}>
          {this.canSave &&
            <Button variant="contained" color="secondary" onClick={() => this.handleSave()}>{this.saveLabel}</Button>
          }
          {stage === stages.length - 1 ? (
            this.renderActions()
          ) : (stage === 4 && context.personKycs.some(({status}) => status === 'unsent')) ? (
            <Button variant="contained" color="primary" onClick={this.handleSendKycInstructions}>Start KYC</Button>
          ) : (
            <Button variant="contained" color="primary" onClick={this.handleNext}>Next</Button>
          )}
        </div>
      </StyledForm>
    )
  }
}

const adminSubmitEvents = {
  draft: 'register',
  registered: 'approve',
  pending_review: 'approve',
}

const rejectEvents = {
  pending_review: 'reject',
  approved: 'unapprove',
}

const userSubmitEvents = {
  draft: 'register',
  registered: 'submit_for_review'
}

const eventLabels = {
  register: 'Register',
  submit_for_review: 'Submit',
  approve: 'Approve',
  reject: 'Reject',
  unapprove: 'Unapprove'
}

const styles = StyleSheet({
  form: {
    '& > button': {
      width: 266,
      marginRight: 20,
      marginBottom: 20,
    }
  },
  buttonBox: {
    maxWidth: 556,
    display: 'flex',
    width: '100%',
    '& > button': {
      flex: 1,
      '&:last-of-type': {
        marginRight: 10
      }
    }
  }
})